import { Button } from 'app/components/buttons';
import { styled } from 'styled-components';

export const ButtonsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`;

export const ConfirmButton = styled(Button)`
  margin-right: ${({ theme }) => theme.spacing()}px;
`;

export const DiscardButton = styled(Button)``;
